export default __webpack_public_path__ + "static/media/void_radio.37472570.svg";